import React from 'react';
import { compose } from 'recompose';
import Layout from '../utils/layout';
import { graphql } from 'gatsby';
import {
  withAuthorization,
  withEmailVerification,
} from '../utils/Session';
import Landing from '../components/scenes/Landing/Landing';

const condition = authUser => !!authUser;
const LandingPage = compose(
  withEmailVerification,
  withAuthorization(condition),
)(Landing);

export default () => {
  return (
    <Layout>
      <LandingPage />
    </Layout>
  );
};

export const query = graphql`
  query HomeSeo {
    site {
      siteMetadata {
        home {
          defaultTitle: title
          titleTemplate
          defaultDescription: description
          siteUrl: url
          defaultImage: image
          twitterUsername
        }
      }
    }
  }
`;
